import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoChevronUpOutline, IoChevronDownOutline } from '../../node_modules/react-icons/io5/index.esm.js';
import Container from '../Container/index.js';
import Button from '../Button/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function ControlledExpandableContainer(props) {
  const {
    className,
    heading,
    children,
    headingDescription,
    alwaysMountedContent,
    headerActions,
    headingContainerClassName,
    headingClassName,
    contentClassName,
    headerClassName,
    headingSize,
    disabled = false,
    expansionButtonClassName,
    expanded,
    name,
    onExpansionChange,
    expansionTriggerArea = 'header',
    spacing = 'comfortable',
    withoutExternalPadding,
    withoutBorder,
    errored,
    ...otherProps
  } = props;
  const mountContent = alwaysMountedContent || expanded;
  const toggleContentVisibility = useCallback(() => {
    onExpansionChange(!expanded, name);
  }, [name, expanded, onExpansionChange]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, otherProps, {
    withoutExternalPadding: withoutExternalPadding,
    className: _cs(styles.expandableContainer, spacingToStyleMap[spacing], withoutExternalPadding && styles.withoutExternalPadding, !withoutBorder && styles.withBorder, expanded && styles.expanded, errored && styles.errored, className),
    headerElementProps: expansionTriggerArea === 'header' && !disabled ? {
      onClick: toggleContentVisibility
    } : undefined,
    headerClassName: _cs(styles.header, headerClassName, expansionTriggerArea === 'header' && !disabled && styles.clickableHeader, errored && styles.errored),
    headingContainerClassName: _cs(styles.headingContainer, headingContainerClassName),
    headingClassName: _cs(styles.heading, headingClassName, errored && styles.errored),
    heading: heading,
    headingSize: headingSize ?? 'small',
    spacing: spacing,
    headerActions: /*#__PURE__*/React.createElement(React.Fragment, null, headerActions, /*#__PURE__*/React.createElement(Button, {
      className: _cs(styles.expandButton, expansionButtonClassName),
      name: undefined,
      onClick: expansionTriggerArea === 'arrow' ? toggleContentVisibility : undefined,
      variant: "action",
      disabled: disabled
    }, expanded ? /*#__PURE__*/React.createElement(IoChevronUpOutline, {
      className: styles.icon
    }) : /*#__PURE__*/React.createElement(IoChevronDownOutline, {
      className: styles.icon
    }))),
    headingDescription: headingDescription,
    contentClassName: _cs(contentClassName, styles.content, !expanded && styles.hidden)
  }), mountContent && children);
}

var ControlledExpandableContainer$1 = genericMemo(ControlledExpandableContainer);

export { ControlledExpandableContainer$1 as default };
//# sourceMappingURL=index.js.map
